import React from 'react';
import { TopToolbar, CreateButton, ExportButton } from 'react-admin';

export const TopToolbarActions = () => (
    <TopToolbar>
        <CreateButton/>
        <ExportButton/>
    </TopToolbar>
);